import { Download, FileJson, FileText } from 'lucide-react';
import { Button } from '../../design-system/Button';
import type { AnalysisReport } from '../../engine/core/types';
import { analysisReportJson, analysisReportText } from '../../engine/reports/serializeReport';
import { downloadBlob } from '../../utilities/download';
import { outputFilename } from '../../engine/core/filenames';

export function ReportsPage({ report }: { report: AnalysisReport }): React.JSX.Element {
  const download = (format: 'json' | 'txt'): void => {
    const value = format === 'json' ? analysisReportJson(report) : analysisReportText(report);
    downloadBlob(new Blob([value], { type: format === 'json' ? 'application/json' : 'text/plain' }), outputFilename(report.file.name, 'RECOVERY_REPORT', format));
  };
  return (
    <article className="reports-page">
      <header><p className="mono label">RECOVERY REPORT</p><h1>Portable local evidence</h1><p>Detailed reports include file and package metadata, relationship targets, hashes, and issue evidence. They exclude spreadsheet values/formulas and recovered Word, ODT, PowerPoint, or PDF page text.</p></header>
      <section className="report-file"><FileText /><div><strong>{report.file.name}</strong><span>{report.issues.length} issues · health {report.health.overall}/100 · SHA-256 recorded</span></div></section>
      <div className="report-options">
        <button type="button" onClick={() => download('json')}><FileJson /><strong>JSON</strong><span>Structured analysis for automation and audit archives.</span><Download /></button>
        <button type="button" onClick={() => download('txt')}><FileText /><strong>TXT</strong><span>Readable summary for tickets and case notes.</span><Download /></button>
      </div>
      <Button variant="quiet" onClick={() => window.print()}>Print or save as PDF</Button>
    </article>
  );
}
